import { useMockUserSwitcher } from './mock-switcher-context';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { UserCog } from 'lucide-react';

/**
 * Dev-only role/depot switcher. Renders only in mock-auth mode:
 * `useMockUserSwitcher()` returns undefined outside the MockAuthProvider,
 * so this is a no-op in production (MSAL) builds.
 */
export function RoleSwitcher() {
  const switcher = useMockUserSwitcher();
  if (!switcher) return null;

  const { users, activeUserId, switchUser } = switcher;

  return (
    <div className="flex items-center gap-2" title="Dev: Rolle/Depot wechseln">
      <UserCog className="h-4 w-4 text-muted-foreground" />
      <Select value={activeUserId} onValueChange={switchUser}>
        <SelectTrigger className="h-8 w-[220px] text-xs">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {users.map((u) => {
            const depotLabel = u.depots && u.depots.length > 0
              ? ` (${u.depots.map((d) => d.key).join(', ')})`
              : '';
            const roleLabel = u.role ? ` — ${u.role}` : '';
            return (
              <SelectItem key={u.id} value={u.id} className="text-xs">
                {u.name}
                {roleLabel}
                {depotLabel}
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
    </div>
  );
}
